import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'

/**
 * Handle chunk loading errors (e.g., after new deployment).
 * When assets are deleted after a new deployment, users with cached pages
 * may encounter import errors. This handler refreshes the page to load new assets.
 * @see https://vite.dev/guide/build#load-error-handling
 */
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
)
